import { CustomProductRoutes } from "./CustomProductRoutes";
import { CoreRoutes } from "./CoreRoutes";
import { ShopifyRoutes } from "./ShopifyRoutes";
import { AdminRoutes } from "./AdminRoutes";
import { BrandResearchRoutes } from "./BrandResearchRoutes";

export const AppRoutes = {
    ...CoreRoutes,
    ...ShopifyRoutes,
    ...CustomProductRoutes,
    ...BrandResearchRoutes,
    ...AdminRoutes,
} as const;
